


















import IconPaginationAnimation from "@/components/icons/IconPaginationAnimation.vue";

export default {
  name: "Dot",
  components: {
    IconPaginationAnimation,
  },
  props: {
    timer: { type: Number, default: 0 },
    current: { type: Boolean, default: false },
    set: { type: Function, default: () => null },
    page: { type: Number, default: 0 },
    length: { type: Number, default: 0 },
    ind: { type: Number, default: 0 },
  },
};
